const getOverriddenItems = (state: AnyFixMe) => state.wixAd.overridden;

export { getOverriddenItems };
